/**
 * global config info
 *
 * @author Shigq
 * @date 2020/12/15 10:27
 */

import store from '@/store'
import { commonUtils } from '@libs/utils'
import { commonApi } from '@/api'
import { listCountryCode, listCurrency } from "@/api/modules/common"
import { useI18n } from "@/plugins/i18n"
import { useLocalCache } from '@/compositions/modules/use-local-cache'
const { locale } = useI18n()
const { LOCAL_DATA_CACHE } = useLocalCache()

/**
 * get constant
 */
async function getConstant() {
  store.dispatch('updateConstant')
}

export async function getRegisterInfo() {
  await store.dispatch('auth/getAcctReviewStatus', store.state.user.userId)
  !store.state.user?.userInfo?.email && (await store.dispatch('user/getUserInfo'))
}

export async function getCountryCode() {
  let res=  listCountryCode({});
  await store.dispatch('updateCountry', res)
  // console.log(res)
}

/**
 * @description 非登录状态，需获取的资源
 */
export async function getStaticConfig() {
  if (!store.state.base.country.list.length) {
    await Promise.all([getConstant(),getCountryCode()])
  }
  // 加载静态字典
  await store.dispatch('updateDict', {})
}

/**
 * @returns {Promise<void>}
 */
export async function getRegInfo() {
  if (commonUtils.isEmpty(store.state.auth.registerInfo)) {
    await Promise.all([getRegisterInfo()])
  }
}
const assembleEcDictionary = list => {
  if (!list || !list.length) return { mappings: {}, options: [] }

  list.sort((a, b) => a.sort - b.sort)

  const ecCountryMap = {}
  const langMap = {
    "zh-cn": "cnName",
    "en": "enName"
  }
  list.forEach((item, index) => {
    ecCountryMap[item.value] = item[langMap[locale]]
    list[index].label = item[langMap[locale]]
  })
  return { mappings: ecCountryMap, options: list }
}
export async function getListDictionaryMapping() {
  try {
    const { list } = await commonApi.listDictionaryMapping({typeList: ['ecCountry', 'ecPlatform']}).catch(() => LOCAL_DATA_CACHE.DICTIONARY_MAPPINGS)
    const countryMapListTarget = (list || []).find(item => item.type === 'ecCountry')
    const platformMapListTarget = (list || []).find(item => item.type === 'ecPlatform')

    const ecCountry = assembleEcDictionary(countryMapListTarget ? [...countryMapListTarget.list] : [])
    const ecPlatform = assembleEcDictionary(platformMapListTarget ? [...platformMapListTarget.list] : [])

    // 调用 clientCountryCode 接口获取国家代码映射
    const countryCodeRes = await commonApi.clientCountryCode({}).catch(() => ({ list: [] }))
    const clientCountryMap = {}
    ;(countryCodeRes.list || []).forEach(item => {
      clientCountryMap[item.code] = item.cnName
    })

    await store.dispatch('updateEcCountryAndPlatform', { ecCountryCode: { ...ecCountry.mappings }, storePlatform: { ...ecPlatform.mappings }, clientCountryCode: clientCountryMap })
  } catch (e) {
    console.log(e)
  }
}